module.exports = __webpack_public_path__ + "img/dentalfit_12_a.fa78b13c.jpg";